/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ChallengeType = {
    UiCustomization: 'ui_customization',
    AuthnContextUpdate: 'authn_context_update',
    Proxy: 'proxy',
    WebauthnCreate: 'webauthn_create',
    WebauthnGet: 'webauthn_get',
    Nonce: 'nonce',
    Otp: 'otp',
    Oidc: 'oidc',
    Saml: 'saml',
    PasswordSet: 'password_set',
    PasswordVerify: 'password_verify',
    PasswordReset: 'password_reset',
    TotpRegister: 'totp_register',
    TotpVerify: 'totp_verify'
} as const;
export type ChallengeType = typeof ChallengeType[keyof typeof ChallengeType];


export function instanceOfChallengeType(value: any): boolean {
    for (const key in ChallengeType) {
        if (Object.prototype.hasOwnProperty.call(ChallengeType, key)) {
            if (ChallengeType[key as keyof typeof ChallengeType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ChallengeTypeFromJSON(json: any): ChallengeType {
    return ChallengeTypeFromJSONTyped(json, false);
}

export function ChallengeTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeType {
    return json as ChallengeType;
}

export function ChallengeTypeToJSON(value?: ChallengeType | null): any {
    return value as any;
}

export function ChallengeTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): ChallengeType {
    return value as ChallengeType;
}

